import React from 'react';

type IconBadgeSize = 'sm' | 'md' | 'lg';
type IconBadgeTone = 'brand' | 'gold' | 'soft';

interface IconBadgeProps {
  children: React.ReactNode;
  size?: IconBadgeSize;
  tone?: IconBadgeTone;
  className?: string;
}

const sizes: Record<IconBadgeSize, string> = {
  sm: 'h-9 w-9 rounded-lg [&>svg]:h-4 [&>svg]:w-4',
  md: 'h-11 w-11 rounded-xl [&>svg]:h-5 [&>svg]:w-5',
  lg: 'h-14 w-14 rounded-xl [&>svg]:h-7 [&>svg]:w-7',
};

const tones: Record<IconBadgeTone, string> = {
  brand: 'border-[#c1cdbd] bg-[#e6ecdf] text-brand-800 shadow-[inset_0_1px_0_rgba(255,255,255,0.5)]',
  gold: 'border-[#d4c49d] bg-[#f0e7ce] text-[#816629] shadow-[inset_0_1px_0_rgba(255,255,255,0.5)]',
  soft: 'border-[#d9d1be] bg-[#efebe0] text-brand-700',
};

export const IconBadge: React.FC<IconBadgeProps> = ({ children, size = 'md', tone = 'brand', className = '' }) => (
  <span aria-hidden="true" className={`inline-flex shrink-0 items-center justify-center border [&>svg]:stroke-[1.7] ${sizes[size]} ${tones[tone]} ${className}`}>
    {children}
  </span>
);

export default IconBadge;
